var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPxCheckWarningRedSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "19px",
    viewBox: "0 0 18 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "px-check-warning-red-small") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF5B45",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF5B45",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "6.-Accident-flow-\\u2013-EG-fleet",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.-Damage-report-overview-\\u2013-Service-lights",
    transform: "translate(-31.000000, -619.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "::-Damage-info",
    transform: "translate(0.000000, 165.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Damage-location",
    transform: "translate(16.000000, 359.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "**-Error-message",
    transform: "translate(0.000000, 81.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "px-check-warning-red-small",
    transform: "translate(16.053156, 15.050000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 13.820598,
    y1: 16.1436877,
    x2: 15.9468439,
    y2: 16.1436877,
    id: "Path-14",
    stroke: "#EF5B45",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.12624585,15.9468439 L6.48973001,0.724448278 C6.6126702,0.295560699 7.00485614,3.51822315e-16 7.45101626,0 L8.40925989,0 C8.8534763,3.12942195e-16 9.24444415,0.293037864 9.3690873,0.719408947 L13.820598,15.9468439 L13.820598,15.9468439",
    id: "Path-3",
    stroke: "url(#linearGradient-1)",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 16.1436877,
    x2: 10.6312292,
    y2: 16.1436877,
    id: "Path-14",
    stroke: "#EF5B45",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94684385,11.95 C7.3945591,11.95 6.94684385,12.3977153 6.94684385,12.95 C6.94684385,13.5022847 7.3945591,13.95 7.94684385,13.95 C8.4991286,13.95 8.94684385,13.5022847 8.94684385,12.95 C8.94684385,12.3977153 8.4991286,11.95 7.94684385,11.95 Z M7.94684385,5.95 C7.3945591,5.95 6.94684385,6.39771525 6.94684385,6.95 L6.94684385,9.95 C6.94684385,10.5022847 7.3945591,10.95 7.94684385,10.95 C8.4991286,10.95 8.94684385,10.5022847 8.94684385,9.95 L8.94684385,6.95 C8.94684385,6.39771525 8.4991286,5.95 7.94684385,5.95 Z",
    id: "px-tyre-pressure-yellow-pic",
    fill: "#EF5B45",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPxCheckWarningRedSmall);
export default __webpack_public_path__ + "static/media/px-check-warning-red-small.6907f1e5299f9b1d87ec2440cf787293.svg";
export { ForwardRef as ReactComponent };